// ❌ can use this until i copy services to this lib
import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { SpeakerCompConfiguration } from '../lessons.clases';
import { TTSGenerated } from '@dataclouder/ngx-vertex';

@Component({
  selector: 'app-speaker',
  templateUrl: './speaker.component.html',
  styleUrls: ['./speaker.component.scss'],
  standalone: true,
  imports: [ButtonModule],
})
export class SpeakerComponent implements OnInit {
  ngOnInit(): void {
    // throw new Error('Method not implemented.');
  }
  @Input() config: SpeakerCompConfiguration;
  @Input() tts: TTSGenerated | undefined;

  //   voiceOptions = VoiceOptions;
  //   constructor(private speachService: SpeechService, private audioService: AudioService) {}
  //   ngOnInit(): void {}
  public speach() {
    console.log('should speech but will do in next version');
  }
}
